module.exports = __webpack_public_path__ + "img/listing-placeholder.823b6da6.png";